/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchedScheduleTypeUpdate } from '../models/PatchedScheduleTypeUpdate';
import type { ProfessionalServicesAgreement } from '../models/ProfessionalServicesAgreement';
import type { ProviderScheduleBulkUpdate } from '../models/ProviderScheduleBulkUpdate';
import type { ProviderScheduleDatesResponse } from '../models/ProviderScheduleDatesResponse';
import type { ScheduleTypeUpdate } from '../models/ScheduleTypeUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProvidersService {

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static providersContractRetrieve({
        id,
        xTz,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/providers/{id}/contract/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
        });
    }

    /**
     * @returns ProfessionalServicesAgreement
     * @throws ApiError
     */
    public static providersContractCreate({
        id,
        xTz,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
        requestBody: ProfessionalServicesAgreement,
    }): CancelablePromise<ProfessionalServicesAgreement> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/providers/{id}/contract/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns binary
     * @throws ApiError
     */
    public static providersContractReviewDownloadRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/providers/{id}/contract-review-download/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Provider schedule endpoints.
     *
     * GET  /api/providers/schedule/dates/?start=YYYY-MM-DD&end=YYYY-MM-DD
     * Returns ``{"allow_dates": [...], "block_dates": [...], "schedule_type": "OPEN"}``.
     * Both arrays cover the same window so a frontend mode-flip needs no
     * second fetch.
     *
     * POST /api/providers/schedule/bulk/
     * Body: ``{"is_blocked": bool, "add": [...], "remove": [...]}``.
     * Returns 204. ``is_blocked`` scopes the mutation to allow rows
     * (false) or block rows (true); the inverse kind is preserved.
     *
     * PATCH /api/providers/schedule/type/
     * Body: ``{"schedule_type": "OPEN"|"CLOSED"|"STRICT"}``.
     * Updates the caller's ``Provider.schedule_type``. Returns the new
     * value. Does not touch any schedule rows.
     *
     * The acting provider is always derived from the request's security context;
     * the body never specifies a provider_id, so a caller cannot mutate another
     * provider's schedule.
     * @returns void
     * @throws ApiError
     */
    public static providersScheduleBulkCreate({
        requestBody,
    }: {
        requestBody: ProviderScheduleBulkUpdate,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/providers/schedule/bulk/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Provider schedule endpoints.
     *
     * GET  /api/providers/schedule/dates/?start=YYYY-MM-DD&end=YYYY-MM-DD
     * Returns ``{"allow_dates": [...], "block_dates": [...], "schedule_type": "OPEN"}``.
     * Both arrays cover the same window so a frontend mode-flip needs no
     * second fetch.
     *
     * POST /api/providers/schedule/bulk/
     * Body: ``{"is_blocked": bool, "add": [...], "remove": [...]}``.
     * Returns 204. ``is_blocked`` scopes the mutation to allow rows
     * (false) or block rows (true); the inverse kind is preserved.
     *
     * PATCH /api/providers/schedule/type/
     * Body: ``{"schedule_type": "OPEN"|"CLOSED"|"STRICT"}``.
     * Updates the caller's ``Provider.schedule_type``. Returns the new
     * value. Does not touch any schedule rows.
     *
     * The acting provider is always derived from the request's security context;
     * the body never specifies a provider_id, so a caller cannot mutate another
     * provider's schedule.
     * @returns ProviderScheduleDatesResponse
     * @throws ApiError
     */
    public static providersScheduleDatesRetrieve({
        end,
        start,
    }: {
        /**
         * Window end, inclusive (YYYY-MM-DD).
         */
        end: string,
        /**
         * Window start, inclusive (YYYY-MM-DD).
         */
        start: string,
    }): CancelablePromise<ProviderScheduleDatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/providers/schedule/dates/',
            query: {
                'end': end,
                'start': start,
            },
        });
    }

    /**
     * Provider schedule endpoints.
     *
     * GET  /api/providers/schedule/dates/?start=YYYY-MM-DD&end=YYYY-MM-DD
     * Returns ``{"allow_dates": [...], "block_dates": [...], "schedule_type": "OPEN"}``.
     * Both arrays cover the same window so a frontend mode-flip needs no
     * second fetch.
     *
     * POST /api/providers/schedule/bulk/
     * Body: ``{"is_blocked": bool, "add": [...], "remove": [...]}``.
     * Returns 204. ``is_blocked`` scopes the mutation to allow rows
     * (false) or block rows (true); the inverse kind is preserved.
     *
     * PATCH /api/providers/schedule/type/
     * Body: ``{"schedule_type": "OPEN"|"CLOSED"|"STRICT"}``.
     * Updates the caller's ``Provider.schedule_type``. Returns the new
     * value. Does not touch any schedule rows.
     *
     * The acting provider is always derived from the request's security context;
     * the body never specifies a provider_id, so a caller cannot mutate another
     * provider's schedule.
     * @returns ScheduleTypeUpdate
     * @throws ApiError
     */
    public static providersScheduleTypePartialUpdate({
        requestBody,
    }: {
        requestBody?: PatchedScheduleTypeUpdate,
    }): CancelablePromise<ScheduleTypeUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/providers/schedule/type/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
